import { jsx as _jsx } from "react/jsx-runtime";
import { DevicePermission } from 'console/device/device_ts';
import { isVehicleDevice } from 'shared/contexts/device/config/utils';
import { LegacyDevice } from 'console/device/device';
import { MaintenanceTab } from 'console/tabs/maintenance/tab';
export const maintenanceTabDefinition = {
    key: 'maintenance',
    title: 'ТО',
    iconclass: 'ui-icon-tab-service',
    should_appear_depends_on: ['maintenances', 'device_type', 'user_id'],
    should_appear: (device, account, r_device, r_account) => 
    // r_device.maintenances != null &&
    LegacyDevice.has_access(r_account.id, r_device, DevicePermission.view_state) &&
        isVehicleDevice(r_device.device_type),
    render: () => _jsx(MaintenanceTab, {}),
};
